class embeddedGeneralSignup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.phoneNumberSubmit();
    this.birthDaySubmit();
    this.checkForUtmParams();
  }

  phoneNumberSubmit() {
    const fakePhoneInputField = this.querySelector('.global_signup_form #fake_phone');
    const phoneInputField = this.querySelector('.global_signup_form #phone');
    if (!fakePhoneInputField || !phoneInputField || typeof window.intlTelInput !== 'function') return;

    const countryCodes = [
      'us', 'gb', 'au', 'ca', 'ie', 'nz', 'de', 'nl', 'fr',
      'be', 'at', 'es', 'ch', 'dk', 'se', 'no', 'fi', 'it', 'pt'
    ];

    const iti = window.intlTelInput(fakePhoneInputField, {
      initialCountry: 'gb',
      separateDialCode: true,
      strictMode: true,
      onlyCountries: countryCodes,
      loadUtils: () => import('https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js'),
    });

    fakePhoneInputField.addEventListener('input', () => {
      if (window.intlTelInput) {
        phoneInputField.value = iti.getNumber(window.intlTelInput.utils.numberFormat.E164);
      }
    });

    fakePhoneInputField.addEventListener('countrychange', () => {
      if (window.intlTelInput) {
        phoneInputField.value = iti.getNumber(window.intlTelInput.utils.numberFormat.E164);
      }
    });
  }

  birthDaySubmit() {
    const dateInputField = this.querySelector('#birthday');
    const fakeDateInputFieldPlaceholder = this.querySelector(".global_signup_form .fake_input_placeholder");
    if (!dateInputField || !fakeDateInputFieldPlaceholder) return;

    dateInputField.addEventListener('change', toggleDateClass);
    fakeDateInputFieldPlaceholder.addEventListener('click', () => {
      if (dateInputField.showPicker) dateInputField.showPicker();
    });

    function toggleDateClass() {
      if (dateInputField.value) {
        fakeDateInputFieldPlaceholder.classList.add("hidden");
        dateInputField.classList.remove('empty');
      } else {
        fakeDateInputFieldPlaceholder.classList.remove("hidden");
        dateInputField.classList.add('empty');
      }
    }

    window.addEventListener("klaviyoFormSubmitted", function () {
      dateInputField.classList.add('empty');
      fakeDateInputFieldPlaceholder.classList.remove("hidden");
    });
  }

  checkForUtmParams() {
    /* 
Grab utm_email 
  ?email=test@example.com
  ?email=test%40example.com 
*/
    const getParam = (name) => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    };

    const utmEmail = getParam("email");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (utmEmail && emailRegex.test(utmEmail)) {
      const emailInput = this.querySelector("#email");
      if (emailInput && !emailInput.value) {
        emailInput.value = utmEmail;
      }
    }
  }
}

customElements.define('embedded-general-signup', embeddedGeneralSignup);
